import * as SharingGroupActions from '../actions/sharing-group'
import { SharingGroup } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'

export interface State {
  groupsById: { [key: number]: SharingGroup }
  groupsByVideo: { [key: number]: SharingGroup[] }
  myGroupByVideo: { [key: number]: SharingGroup }
  sharingGroupFilterByVideo: { [key: number]: number[] }
}

const initialState: State = {
  groupsById: {},
  groupsByVideo: {},
  myGroupByVideo: {},
  sharingGroupFilterByVideo: {},
}

export function reducer(state: State = initialState, action: SharingGroupActions.All): State {
  switch (action.type) {
    case SharingGroupActions.SET_VIDEO_GROUPS: {
      state.groupsByVideo[action.videoId] = action.groups
      for (const g of action.groups) {
        state.groupsById[g.id] = g
      }
      break
    }
    case SharingGroupActions.ADD_VIDEO_GROUP: {
      state.groupsByVideo[action.videoId].unshift(action.group)
      state.groupsById[action.group.id] = action.group
      break
    }
    case SharingGroupActions.UPDATE_VIDEO_GROUP: {
      const idx = state.groupsByVideo[action.videoId].findIndex(g => g.id === action.group.id)
      if(idx > -1) {
        state.groupsByVideo[action.videoId][idx] = action.group
      } else {
        state.groupsByVideo[action.videoId].unshift(action.group)
      }
      state.groupsById[action.group.id] = action.group
      break
    }
    case SharingGroupActions.DESTROY_VIDEO_GROUP: {
      const idx = state.groupsByVideo[action.videoId].findIndex(g => g.id === action.groupId)
      if(idx > -1) {
        state.groupsByVideo[action.videoId].splice(idx, 1)
      }
      delete state.groupsById[action.groupId]
      break
    }
    case SharingGroupActions.SET_VIDEO_MY_GROUP: {
      state.myGroupByVideo[action.videoId] = action.group
      break
    }
    case SharingGroupActions.SET_GROUP_FILTER_STATUS: {
      state.sharingGroupFilterByVideo[action.videoId] = action.filterGroupIds
      break
    }
    default: {
      return state
    }
  }
  return { ...state,
      groupsById: { ...state.groupsById },
      groupsByVideo: { ...state.groupsByVideo },
      myGroupByVideo: { ...state.myGroupByVideo },
      sharingGroupFilterByVideo: { ...state.sharingGroupFilterByVideo },
    }
}



// WEBPACK FOOTER //
// ./src/reducers/sharing-group.ts